const firebaseConfig = {
    apiKey: "AIzaSyD3rBTYWu7P0YEigxctOXn4PnDlgJuL5Kg",
    authDomain: "ema-john-simple1-67b3f.firebaseapp.com",
    databaseURL: "https://ema-john-simple1-67b3f.firebaseio.com",
    projectId: "ema-john-simple1-67b3f",
    storageBucket: "ema-john-simple1-67b3f.appspot.com",
    messagingSenderId: "515824794468",
    appId: "1:515824794468:web:4e54f5c5a40655be445871",
    measurementId: "G-RLRN6WM0LJ"
  };

export default firebaseConfig;